<wipperoz-progress-bar></wipperoz-progress-bar>
<div class="main-window">
  <router-outlet></router-outlet>
</div>
